import type { SVGProps } from 'react';

const SvgPlayerViewNormal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M16 9h4c.55 0 1-.45 1-1s-.45-1-1-1h-3V4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1m-8 6H4c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1m12 0h-4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1M8 3c-.55 0-1 .45-1 1v3H4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1"
    />
  </svg>
);
export default SvgPlayerViewNormal;
